import { trackingStatusLabel } from "@/utils/publicTracking/trackingStatus";
import type { TrackingOverallStatus } from "@/utils/publicTracking/types";

/** Group the 31-digit IMb into 4-char blocks for display (raw value unchanged). */
function groupImb(imb: string): string {
  return imb.replace(/(.{4})/g, "$1 ").trim();
}

interface StatusHeroProps {
  status: TrackingOverallStatus;
  imb: string;
}

export function StatusHero({ status, imb }: StatusHeroProps) {
  return (
    <div className="space-y-2">
      <p className="text-muted-foreground text-[10px] font-medium tracking-wider uppercase">
        Status
      </p>
      <h1 className="text-4xl font-semibold tracking-tight">
        {trackingStatusLabel(status)}
      </h1>
      <p className="text-muted-foreground flex flex-wrap items-center gap-2 text-sm">
        Tracking ID (IMb):
        <span className="bg-muted text-foreground rounded px-1.5 py-0.5 font-mono text-xs">
          {groupImb(imb)}
        </span>
      </p>
    </div>
  );
}
